import React, { useEffect } from "react";
import { Col, Container, Row } from "react-bootstrap";
import TableLayout from "../../../components/TableLayout";
import TableActions from "../../../components/Common/TableActions";
import CustomPagination from "../../../components/Common/CustomPagination";
import Filter from "../../../components/Common/Filter";
import { Link, useLocation } from "react-router-dom";
import dataHandler from "../../../hooks/dataHandler";
import { APPINTRO, REMOVEAPPINTRO, REVIEWREQUEST, ROOMDELETE, ROOMLIST } from "../../../services/ApiCalls";
import { AppIntoListFilterOptions, ReviewRequestFilterOptions } from "../../../utilities/const";
import ConfirmationPop from "../../../components/Modals/ConfirmationPop";
import { useTranslation } from "react-i18next";
import moment from "moment";

const ManageReviewRequest = () => {
  const location = useLocation();
  const { t } = useTranslation();
  const {
    setBody,
    body,
    data,
    loader,
    deleteModel,
    setDeleteModel,
    paginationHandler,
    searchHandler,
    total,
    deleteHandler,
  } = dataHandler({
    api: REVIEWREQUEST,
  });

  useEffect(() => {
    const queryPage = new URLSearchParams(location.search).get("page");

    if (queryPage) {
      setBody((p) => ({ ...p, page: Number(queryPage) }));
    }
  }, []);

  const column = [
    {
      head: t("manageRoom.columns.srNo"),
      accessor: "#",
      component: (item, key) => <>{key < 9 ? `0${key + 1}` : key + 1}</>,
    },
    {
      head: t("reviewRequest.columns.hotel"),
      accessor: "hotelName",
      component: (item) => <><span
        className="text-truncate d-inline-block"
        style={{ maxWidth: "150px" }}
      >
        {item?.hotelId?.hotelName}
      </span></>,
    },
    {
      head: t("reviewRequest.columns.customerName"),
      accessor: "hotelId",
      component: (item) => <><span
        className="text-truncate d-inline-block"
        style={{ maxWidth: "150px" }}
      >
        {item?.customerId?.first_name+" "+item?.customerId?.last_name}
      </span></>,
    },
    {
      head: t("reviewRequest.columns.customerEmail"),
      accessor: "roomNumber",
      component: (item) => <span className="d-flex justify-content-center align-items-center">{item?.customerId?.email}</span>,
    },
    {
      head: t("reviewRequest.columns.mobile"),
      accessor: "roomNumber",
      component: (item) => <span className="d-flex justify-content-center align-items-center">{item?.customerId?.countryCode}{item?.customerId?.mobileNumber}</span>,
    },

    {
      head: t("appIntro.columns.createdAt"),
      accessor: "roomType",
      component: (item) => {
        const time = item?.createdAt;


        const formatted = moment(
          typeof time === "number" ? `${time}:00` : time,
          ["H:mm", "HH:mm", "HH:mm:ss", moment.ISO_8601],
          true
        ).format("h:mm A");

        return (
          <span className="d-flex justify-content-center align-items-center" >
            {formatted === "Invalid date" ? "--" : formatted}
          </span>
        );
      },
    },

    {
      head: t("manageRoom.columns.status"),
      accessor: "status",
      component: (item) => (
        <span
          className={`badge ${item.status === "Available" ? "bg-success" : "bg-secondary"
            }`}
        >
          {item.status}
        </span>
      ),
    },
    {
      head: t("manageRoom.columns.action"),
      accessor: "action",
      component: (item) => (
        <TableActions
          // editUrl={`/appintro/edit/${item._id}`}
          viewLink={`/reviewRequest/detail/${item._id}`}
          // setDeleteModel={() =>
          //   setDeleteModel({ show: true, dumpId: item._id })
          // }
        />
      ),
    },
  ];

  return (
    <>
      <ConfirmationPop
        type={"delete"}
        confirmation={deleteModel.show}
        setConfirmation={() =>
          setDeleteModel({
            show: false,
            dumpId: "",
          })
        }
        confirmHandler={() =>
          deleteHandler(() => REMOVEAPPINTRO({ _id: deleteModel.dumpId }))
        }
      />
      <section className="room-management py-3 position-relative">
        <Container>
          <Row>
            <Col lg="12">
              <div className="d-flex justify-content-between align-items-end">
                <h4 className="mb-0 py-3 fw-bold text-dark text-capitalize">
                  {t("reviewRequest.title")}
                </h4>

                {/* <div className="d-flex align-items-center gap-2">
                  <label
                    htmlFor="countryFilter"
                    className="form-label m-0 fw-semibold text-muted"
                    style={{ whiteSpace: "nowrap" }}
                  >
                    {t("manageRoom.filter")}
                  </label>
                  <CountryFilter
                    id="countryFilter"
                    body={body}
                    setBody={setBody}
                  />
                </div> */}
              </div>
            </Col>
            <Col lg="12" className="my-2">
              <div className="tableFilter d-flex align-items-end justify-content-between flex-wrap gap-10 mb-3">
                <div className="left">
                  <Filter
                    body={body}
                    // searchHandler={searchHandler}
                    type={"rr"}

                    setBody={setBody}
                    statusFilterOptionArr={ReviewRequestFilterOptions}
                  />
                </div>
                {/* <div className="right d-flex align-items-end gap-3">
                  <Link
                    to="/appintro/add"
                    className="d-flex btn btn-primary align-items-center justify-content-center fw-sbold commonBtn "
                    style={{ height: 40, minWidth: 100, fontSize: 12 }}
                  >
                    {t("appIntro.addAppIntro")}
                  </Link>
                </div> */}
              </div>
            </Col>
            <Col lg="12" className="my-2">
              <TableLayout column={column} data={data} loader={loader} />
              <CustomPagination
                total={total}
                pageChangeHandler={paginationHandler}
                body={body}
                setBody={setBody}
              />
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default ManageReviewRequest;
